import { render } from "./ImportTrainees.vue?vue&type=template&id=74f5b14b&scoped=true"
import script from "./ImportTrainees.vue?vue&type=script&lang=js"
export * from "./ImportTrainees.vue?vue&type=script&lang=js"

import "./ImportTrainees.vue?vue&type=style&index=0&id=74f5b14b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f5b14b"]])

export default __exports__